
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.md?watch=parent';
    export const demoIndex = {
  ids: ["indentedtree-demo-common","indentedtree-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__IndentedTree__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/IndentedTree/index.md?type=demo')
};